import { cloneDeep, get } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets, proxy, validation } from '@/utils'

import render from './render'

export default {
  name: 'UsersBasicFormPhone',

  mixins: [
    proxy({ type: 'object' }),
    validation
  ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      showDialog: false,

      initIsVerifiedByPhone: cloneDeep(get(this.value, 'data.meta.isVerifiedByPhone', false))
    }
  },

  computed: {
    canUpdateUsersAsAdmin() {
      return this.checkPermissions(`advanced.${Services.users}.update`)
    },
    canUpdateUsersAsUser() {
      return this.checkPermissions(`advanced.${Services.users}.update`, permissionPresets.me)
    },

    isVerifiedByPhone() {
      return Boolean(get(this.proxy, 'data.meta.isVerifiedByPhone', false))
    },

    isOtpVerificationAvailable() {
      return Boolean(get(this.globalSettings, 'isOtpVerificationAvailable', false))
    },

    disabled() {
      return this.isVerifiedByPhone
    },

    validation() {
      return true
    }
  },

  methods: {
    onConfirmed() {
      this.proxy.data.meta = this.proxy.data.meta || {}
      this.proxy.data.meta.isVerifiedByPhone = true
    }
  },

  render
}
